module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Medium.57efe8c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Medium.eot?
// module id = rt3t
// module chunks = 0